"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRichText = exports.isEmail = exports.isPwCEmail = exports.getUserInitials = exports.slugify = void 0;
var slugify = function (input, removeSpecialCharacters) {
    if (!input) {
        return '';
    }
    var newString = input.toLowerCase().replace(/\s/g, '-');
    if (removeSpecialCharacters) {
        return newString.replace(/[^a-z-]/g, '');
    }
    return newString;
};
exports.slugify = slugify;
var getUserInitials = function (givenName, familyName) {
    var givenInitial = givenName && givenName.trim().length ? givenName[0] : '';
    var familyInitial = familyName && familyName.trim().length ? familyName[0] : '';
    return givenInitial + familyInitial;
};
exports.getUserInitials = getUserInitials;
var isPwCEmail = function (email) {
    var isValid = /@pwc\.com$/i.test(email) || /@devpwc365\.com$/i.test(email);
    return isValid;
};
exports.isPwCEmail = isPwCEmail;
var isEmail = function (email) {
    var isValid = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(email) ||
        /@devpwc365\.com$/i.test(email);
    return isValid;
};
exports.isEmail = isEmail;
var parseRichText = function (isShared, data) {
    var richText;
    try {
        if (isShared) {
            richText = data;
        }
        else {
            richText = JSON.parse(data).RichTextData;
        }
    }
    catch (e) {
        richText = '<h5>Failed To Load Content</h5>';
    }
    return richText;
};
exports.parseRichText = parseRichText;
